import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import {
  clearSession,
  createSessionRefreshHandler,
  hydrateSession,
  openAuthView,
} from './modules/auth';
import { setSessionRefreshHandler, setUnauthorizedHandler } from './modules/api/client';
import App from './containers/App';
import AdminRouter from './containers/admin/AdminRouter';

import './index.css';
import 'antd/dist/reset.css';

const rootElement = document.getElementById('root');

function redirectToLogin(isAdminSession = false) {
  store.dispatch(clearSession());

  if (isAdminSession) {
    if (history.location.pathname !== '/admin/login') {
      history.replace('/admin/login');
    }
    return;
  }

  if (history.location.pathname !== '/') {
    history.replace('/');
  }
  store.dispatch(openAuthView('login'));
}

store.dispatch(hydrateSession());
setSessionRefreshHandler(createSessionRefreshHandler(store));

setUnauthorizedHandler((error) => {
  const requestUrl = (error && error.config && error.config.url) || '';
  redirectToLogin(requestUrl.indexOf('/admin') === 0);
});

if (typeof window !== 'undefined') {
  window.addEventListener('storage', (event) => {
    const state = store.getState();
    const auth = state && state.auth;

    if (event.key === 'asi:token' && event.newValue === null && auth && auth.token) {
      redirectToLogin(false);
    }

    if (
      event.key === 'asi:admin-token'
      && event.newValue === null
      && auth
      && auth.admin
      && auth.admin.token
    ) {
      redirectToLogin(true);
    }
  });
}

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/admin" component={AdminRouter} />
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  rootElement,
);
